import React, { useState } from "react"
import styles from "./ChatUi.module.css"
import PreviewImage from "../common/previewImage"
interface imageProps {
  imageUpload: {
    mediaFiles: [] | any
    profilePic: string
  }
  isAdmin: string
}
const ChatImage = ({ imageUpload, isAdmin }: imageProps) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const handleImageClick = (image: string) => {
    setSelectedImage(image)
  }

  const handleClose = () => {
    setSelectedImage(null)
  }

  return (
    <div
      className={`d-flex ${
        isAdmin ? "justify-content-end" : ""
      } mt-0 gap-0 w-100 ${styles["Chat-image-sec"]}`}
    >
      {imageUpload?.mediaFiles?.map((media: any, index: number) => (
        <img
          className={`${styles["image-upload-sec"]}`}
          onClick={() => handleImageClick(media)}
          key={index}
          src={media}
          style={{
            width: imageUpload.mediaFiles.length === 1 ? "150x" : "120px",
            height: imageUpload.mediaFiles.length === 1 ? "150px" : "120px",
            objectFit: "cover",
            marginTop: "30px",
          }}
        />
      ))}

      <PreviewImage
        selectedImage={selectedImage}
        handleClosePreview={handleClose}
      />
    </div>
  )
}

export default ChatImage
